import React from 'react';
import { render } from 'react-dom';

import { getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import MakePaymentDetails from '../react/MakePaymentDetails';

export default class MakePaymentDetailsRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model, loadApi } = this.context.dataset;
    if (!apiUrl || !model || !loadApi) throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    jsonGet(loadApi, null, (response) => {
      if (response.errorCode) {
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(MakePaymentDetailsRender.renderMain(response, labels, apiUrl), this.context);
    });

    return render(MakePaymentDetailsRender.renderMain(undefined, labels, apiUrl), this.context);
  }

  static renderMain(data, labels, apiUrl) {
    return data ? <MakePaymentDetails labels={labels} data={data} apiURL={apiUrl} /> : <Loading />;
  }
}
